import { render, staticRenderFns } from "./BarraAvance.vue?vue&type=template&id=36e39703&"
import script from "./BarraAvance.vue?vue&type=script&lang=js&"
export * from "./BarraAvance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports